import { faChevronDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Text } from 'components/primitives'

export const InfoBanner = ({ text }: { text: string }) => {
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '$iris7',
        borderColor: '$iris10',
        borderWidth: 1,
        borderRadius: 8,
        p: '$3',
        mt: '$5',
      }}
    >
      <FontAwesomeIcon
        icon={faInfoCircle}
        style={{ marginRight: '8px' }}
        width="16"
        height="16"
      />
      <Text style="body1" css={{ textAlign: 'center', fontWeight: 500 }}>
        {text}
      </Text>
    </Box>
  )
}
